export const getInitials = name => {
	const nameParts = name.split(' ');
	const initials = nameParts
		.map(part => part.charAt(0).toUpperCase())
		.slice(0, 2)
		.join('');
	return initials;
};

export const formatTimestamp = timestamp => {
	const date = new Date(timestamp);
	const options = { month: 'long', day: 'numeric', year: 'numeric' };
	return date.toLocaleDateString('en-US', options);
};
